// Quote
export { default as QuoteSlideshow } from "./QuoteSlideshow";
export type { default as QuoteSlideshowProps } from "./QuoteSlideshowProps.interface";